export const FLAG: Record<string, string> = {
  Mexico: "🇲🇽",
  "South Africa": "🇿🇦",
  "Korea Republic": "🇰🇷",
  "South Korea": "🇰🇷",
  "Czech Republic": "🇨🇿",
  Canada: "🇨🇦",
  "Bosnia & Herzegovina": "🇧🇦",
  USA: "🇺🇸",
  Paraguay: "🇵🇾",
  Qatar: "🇶🇦",
  Switzerland: "🇨🇭",
  Brazil: "🇧🇷",
  Morocco: "🇲🇦",
  Haiti: "🇭🇹",
  Scotland: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  Australia: "🇦🇺",
  Türkiye: "🇹🇷",
  Germany: "🇩🇪",
  Curaçao: "🇨🇼",
  "Ivory Coast": "🇨🇮",
  Ecuador: "🇪🇨",
  Netherlands: "🇳🇱",
  Japan: "🇯🇵",
  Sweden: "🇸🇪",
  Tunisia: "🇹🇳",
  Spain: "🇪🇸",
  "Cape Verde": "🇨🇻",
  "Saudi Arabia": "🇸🇦",
  Uruguay: "🇺🇾",
  Belgium: "🇧🇪",
  Egypt: "🇪🇬",
  Iran: "🇮🇷",
  "New Zealand": "🇳🇿",
  France: "🇫🇷",
  Senegal: "🇸🇳",
  Iraq: "🇮🇶",
  Norway: "🇳🇴",
  Argentina: "🇦🇷",
  Algeria: "🇩🇿",
  Austria: "🇦🇹",
  Jordan: "🇯🇴",
  Portugal: "🇵🇹",
  "DR Congo": "🇨🇩",
  Uzbekistan: "🇺🇿",
  Colombia: "🇨🇴",
  England: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
  // API name variants
  "United States": "🇺🇸",
  "Bosnia and Herzegovina": "🇧🇦",
  "Democratic Republic of Congo": "🇨🇩",
  "Republic of Korea": "🇰🇷",
  Croatia: "🇭🇷",
  Ghana: "🇬🇭",
  Panama: "🇵🇦",
};

export const ABBR = (t: string): string =>
  ({
    "South Africa": "RSA",
    "Korea Republic": "KOR",
    "Bosnia & Herzegovina": "BIH",
    "New Zealand": "NZL",
    "Saudi Arabia": "KSA",
    "Cape Verde": "CPV",
    "Ivory Coast": "CIV",
    "DR Congo": "COD",
  }[t] || t.slice(0, 3).toUpperCase());

export const MATCHES = [
  {
    id: "m01",
    grp: "A",
    date: "2026-06-11",
    koUTC: "2026-06-11T19:00:00Z",
    t1: "Mexico",
    t2: "South Africa",
    p1: 0.55,
    pX: 0.27,
    p2: 0.18,
  },
  {
    id: "m02",
    grp: "A",
    date: "2026-06-12",
    koUTC: "2026-06-12T02:00:00Z",
    t1: "Korea Republic",
    t2: "Czech Republic",
    p1: 0.42,
    pX: 0.29,
    p2: 0.29,
  },
  {
    id: "m03",
    grp: "B",
    date: "2026-06-12",
    koUTC: "2026-06-12T19:00:00Z",
    t1: "Canada",
    t2: "Bosnia & Herzegovina",
    p1: 0.55,
    pX: 0.26,
    p2: 0.19,
  },
  {
    id: "m04",
    grp: "D",
    date: "2026-06-13",
    koUTC: "2026-06-13T01:00:00Z",
    t1: "USA",
    t2: "Paraguay",
    p1: 0.52,
    pX: 0.27,
    p2: 0.21,
  },
  {
    id: "m05",
    grp: "B",
    date: "2026-06-13",
    koUTC: "2026-06-13T19:00:00Z",
    t1: "Qatar",
    t2: "Switzerland",
    p1: 0.2,
    pX: 0.27,
    p2: 0.53,
  },
  {
    id: "m06",
    grp: "C",
    date: "2026-06-13",
    koUTC: "2026-06-13T22:00:00Z",
    t1: "Brazil",
    t2: "Morocco",
    p1: 0.62,
    pX: 0.24,
    p2: 0.14,
  },
  {
    id: "m07",
    grp: "C",
    date: "2026-06-14",
    koUTC: "2026-06-14T17:00:00Z",
    t1: "Scotland",
    t2: "Haiti",
    p1: 0.5,
    pX: 0.28,
    p2: 0.22,
  },
  {
    id: "m08",
    grp: "D",
    date: "2026-06-14",
    koUTC: "2026-06-14T20:00:00Z",
    t1: "Australia",
    t2: "Türkiye",
    p1: 0.34,
    pX: 0.3,
    p2: 0.36,
  },
  {
    id: "m09",
    grp: "E",
    date: "2026-06-14",
    koUTC: "2026-06-14T16:00:00Z",
    t1: "Germany",
    t2: "Curaçao",
    p1: 0.86,
    pX: 0.1,
    p2: 0.04,
  },
  {
    id: "m10",
    grp: "E",
    date: "2026-06-14",
    koUTC: "2026-06-14T23:00:00Z",
    t1: "Ivory Coast",
    t2: "Ecuador",
    p1: 0.42,
    pX: 0.3,
    p2: 0.28,
  },
  {
    id: "m11",
    grp: "F",
    date: "2026-06-14",
    koUTC: "2026-06-14T18:00:00Z",
    t1: "Netherlands",
    t2: "Japan",
    p1: 0.58,
    pX: 0.25,
    p2: 0.17,
  },
  {
    id: "m12",
    grp: "F",
    date: "2026-06-14",
    koUTC: "2026-06-14T21:00:00Z",
    t1: "Sweden",
    t2: "Tunisia",
    p1: 0.52,
    pX: 0.28,
    p2: 0.2,
  },
  {
    id: "u01",
    grp: "H",
    date: "2026-06-15",
    koUTC: "2026-06-15T16:00:00Z",
    t1: "Spain",
    t2: "Cape Verde",
    p1: 0.82,
    pX: 0.13,
    p2: 0.05,
  },
  {
    id: "u03",
    grp: "G",
    date: "2026-06-15",
    koUTC: "2026-06-15T19:00:00Z",
    t1: "Belgium",
    t2: "Egypt",
    p1: 0.62,
    pX: 0.24,
    p2: 0.14,
  },
  {
    id: "u02",
    grp: "H",
    date: "2026-06-15",
    koUTC: "2026-06-15T22:00:00Z",
    t1: "Saudi Arabia",
    t2: "Uruguay",
    p1: 0.2,
    pX: 0.27,
    p2: 0.53,
  },
  {
    id: "u04",
    grp: "G",
    date: "2026-06-15",
    koUTC: "2026-06-16T01:00:00Z",
    t1: "Iran",
    t2: "New Zealand",
    p1: 0.55,
    pX: 0.28,
    p2: 0.17,
  },
  {
    id: "u05",
    grp: "I",
    date: "2026-06-16",
    koUTC: "2026-06-16T19:00:00Z",
    t1: "France",
    t2: "Senegal",
    p1: 0.58,
    pX: 0.25,
    p2: 0.17,
  },
  {
    id: "u06",
    grp: "I",
    date: "2026-06-16",
    koUTC: "2026-06-16T22:00:00Z",
    t1: "Iraq",
    t2: "Norway",
    p1: 0.22,
    pX: 0.28,
    p2: 0.5,
  },
  {
    id: "u07",
    grp: "J",
    date: "2026-06-16",
    koUTC: "2026-06-17T01:00:00Z",
    t1: "Argentina",
    t2: "Algeria",
    p1: 0.78,
    pX: 0.15,
    p2: 0.07,
  },
  {
    id: "u08",
    grp: "J",
    date: "2026-06-16",
    koUTC: "2026-06-17T04:00:00Z",
    t1: "Austria",
    t2: "Jordan",
    p1: 0.6,
    pX: 0.26,
    p2: 0.14,
  },
  {
    id: "u09",
    grp: "K",
    date: "2026-06-17",
    koUTC: "2026-06-17T17:00:00Z",
    t1: "Portugal",
    t2: "DR Congo",
    p1: 0.7,
    pX: 0.2,
    p2: 0.1,
  },
  {
    id: "u11",
    grp: "L",
    date: "2026-06-17",
    koUTC: "2026-06-17T20:00:00Z",
    t1: "England",
    t2: "Croatia",
    p1: 0.48,
    pX: 0.28,
    p2: 0.24,
  },
  {
    id: "u12",
    grp: "L",
    date: "2026-06-17",
    koUTC: "2026-06-17T23:00:00Z",
    t1: "Ghana",
    t2: "Panama",
    p1: 0.5,
    pX: 0.28,
    p2: 0.22,
  },
  {
    id: "u10",
    grp: "K",
    date: "2026-06-17",
    koUTC: "2026-06-18T02:00:00Z",
    t1: "Uzbekistan",
    t2: "Colombia",
    p1: 0.22,
    pX: 0.28,
    p2: 0.5,
  },
  {
    id: "u13",
    grp: "A",
    date: "2026-06-18",
    koUTC: "2026-06-18T16:00:00Z",
    t1: "Czech Republic",
    t2: "South Africa",
    p1: 0.44,
    pX: 0.29,
    p2: 0.27,
  },
  {
    id: "u14",
    grp: "B",
    date: "2026-06-18",
    koUTC: "2026-06-18T19:00:00Z",
    t1: "Switzerland",
    t2: "Bosnia & Herzegovina",
    p1: 0.55,
    pX: 0.27,
    p2: 0.18,
  },
  {
    id: "u15",
    grp: "B",
    date: "2026-06-18",
    koUTC: "2026-06-18T22:00:00Z",
    t1: "Canada",
    t2: "Qatar",
    p1: 0.58,
    pX: 0.26,
    p2: 0.16,
  },
  {
    id: "u16",
    grp: "A",
    date: "2026-06-18",
    koUTC: "2026-06-19T01:00:00Z",
    t1: "Mexico",
    t2: "Korea Republic",
    p1: 0.42,
    pX: 0.29,
    p2: 0.29,
  },
  {
    id: "u17",
    grp: "D",
    date: "2026-06-19",
    koUTC: "2026-06-19T19:00:00Z",
    t1: "USA",
    t2: "Australia",
    p1: 0.52,
    pX: 0.27,
    p2: 0.21,
  },
  {
    id: "u18",
    grp: "C",
    date: "2026-06-19",
    koUTC: "2026-06-19T22:00:00Z",
    t1: "Scotland",
    t2: "Morocco",
    p1: 0.28,
    pX: 0.3,
    p2: 0.42,
  },
  {
    id: "u19",
    grp: "C",
    date: "2026-06-19",
    koUTC: "2026-06-20T01:00:00Z",
    t1: "Brazil",
    t2: "Haiti",
    p1: 0.85,
    pX: 0.11,
    p2: 0.04,
  },
  {
    id: "u20",
    grp: "D",
    date: "2026-06-19",
    koUTC: "2026-06-20T04:00:00Z",
    t1: "Türkiye",
    t2: "Paraguay",
    p1: 0.4,
    pX: 0.29,
    p2: 0.31,
  },

  // ── Journée 2 · Groupes E-L ─────────────────────────────────────────────
  { id: "v01", grp: "E", date: "2026-06-21", koUTC: "2026-06-21T20:00:00Z", t1: "Germany",     t2: "Ivory Coast",           p1: 0.62, pX: 0.23, p2: 0.15 },
  { id: "v02", grp: "E", date: "2026-06-21", koUTC: "2026-06-21T23:00:00Z", t1: "Curaçao",     t2: "Ecuador",               p1: 0.14, pX: 0.25, p2: 0.61 },
  { id: "v03", grp: "F", date: "2026-06-22", koUTC: "2026-06-22T17:00:00Z", t1: "Netherlands", t2: "Sweden",                p1: 0.46, pX: 0.28, p2: 0.26 },
  { id: "v04", grp: "F", date: "2026-06-22", koUTC: "2026-06-22T20:00:00Z", t1: "Japan",       t2: "Tunisia",               p1: 0.44, pX: 0.29, p2: 0.27 },
  { id: "v05", grp: "G", date: "2026-06-22", koUTC: "2026-06-22T23:00:00Z", t1: "Belgium",     t2: "Iran",                  p1: 0.60, pX: 0.24, p2: 0.16 },
  { id: "v06", grp: "G", date: "2026-06-23", koUTC: "2026-06-23T02:00:00Z", t1: "Egypt",       t2: "New Zealand",           p1: 0.50, pX: 0.28, p2: 0.22 },
  { id: "v07", grp: "H", date: "2026-06-23", koUTC: "2026-06-23T17:00:00Z", t1: "Spain",       t2: "Saudi Arabia",          p1: 0.72, pX: 0.19, p2: 0.09 },
  { id: "v08", grp: "H", date: "2026-06-23", koUTC: "2026-06-23T20:00:00Z", t1: "Cape Verde",  t2: "Uruguay",               p1: 0.18, pX: 0.27, p2: 0.55 },
  { id: "v09", grp: "I", date: "2026-06-23", koUTC: "2026-06-23T20:00:00Z", t1: "France",      t2: "Iraq",                  p1: 0.70, pX: 0.19, p2: 0.11 },
  { id: "v10", grp: "I", date: "2026-06-23", koUTC: "2026-06-23T23:00:00Z", t1: "Senegal",     t2: "Norway",                p1: 0.38, pX: 0.30, p2: 0.32 },
  { id: "v11", grp: "J", date: "2026-06-24", koUTC: "2026-06-24T02:00:00Z", t1: "Argentina",   t2: "Austria",               p1: 0.70, pX: 0.19, p2: 0.11 },
  { id: "v12", grp: "J", date: "2026-06-24", koUTC: "2026-06-24T20:00:00Z", t1: "Algeria",     t2: "Jordan",                p1: 0.52, pX: 0.27, p2: 0.21 },
  { id: "v13", grp: "K", date: "2026-06-24", koUTC: "2026-06-24T23:00:00Z", t1: "Portugal",    t2: "Uzbekistan",            p1: 0.70, pX: 0.19, p2: 0.11 },
  { id: "v14", grp: "K", date: "2026-06-25", koUTC: "2026-06-25T02:00:00Z", t1: "DR Congo",    t2: "Colombia",              p1: 0.30, pX: 0.30, p2: 0.40 },
  { id: "v15", grp: "L", date: "2026-06-23", koUTC: "2026-06-23T20:00:00Z", t1: "England",     t2: "Ghana",                 p1: 0.58, pX: 0.27, p2: 0.15 },
  { id: "v16", grp: "L", date: "2026-06-23", koUTC: "2026-06-23T23:00:00Z", t1: "Croatia",     t2: "Panama",                p1: 0.56, pX: 0.27, p2: 0.17 },

  // ── Journée 3 · Groupes A-D (simultanés par groupe) ─────────────────────
  { id: "w01", grp: "A", date: "2026-06-25", koUTC: "2026-06-25T01:00:00Z", t1: "Mexico",      t2: "Czech Republic",               p1: 0.44, pX: 0.29, p2: 0.27 },
  { id: "w02", grp: "A", date: "2026-06-24", koUTC: "2026-06-24T00:00:00Z", t1: "South Africa", t2: "Korea Republic",       p1: 0.28, pX: 0.30, p2: 0.42 },
  { id: "w03", grp: "B", date: "2026-06-24", koUTC: "2026-06-24T19:00:00Z", t1: "Canada",      t2: "Switzerland",           p1: 0.40, pX: 0.28, p2: 0.32 },
  { id: "w04", grp: "B", date: "2026-06-24", koUTC: "2026-06-24T19:00:00Z", t1: "Bosnia & Herzegovina", t2: "Qatar",     p1: 0.52, pX: 0.28, p2: 0.20 },
  { id: "w05", grp: "C", date: "2026-06-24", koUTC: "2026-06-24T22:00:00Z", t1: "Brazil",      t2: "Scotland",              p1: 0.65, pX: 0.22, p2: 0.13 },
  { id: "w06", grp: "C", date: "2026-06-24", koUTC: "2026-06-24T22:00:00Z", t1: "Morocco",     t2: "Haiti",                 p1: 0.68, pX: 0.20, p2: 0.12 },
  { id: "w07", grp: "D", date: "2026-06-25", koUTC: "2026-06-25T00:00:00Z", t1: "USA",         t2: "Türkiye",               p1: 0.52, pX: 0.23, p2: 0.25 },
  { id: "w08", grp: "D", date: "2026-06-25", koUTC: "2026-06-25T00:00:00Z", t1: "Australia",   t2: "Paraguay",              p1: 0.25, pX: 0.42, p2: 0.33 },

  // ── Journée 3 · Groupes E-H ─────────────────────────────────────────────
  { id: "w09", grp: "E", date: "2026-06-25", koUTC: "2026-06-25T00:00:00Z", t1: "Germany",     t2: "Ecuador",               p1: 0.64, pX: 0.19, p2: 0.17 },
  { id: "w10", grp: "E", date: "2026-06-25", koUTC: "2026-06-25T00:00:00Z", t1: "Ivory Coast", t2: "Curaçao",               p1: 0.83, pX: 0.12, p2: 0.05 },
  { id: "w11", grp: "F", date: "2026-06-25", koUTC: "2026-06-25T00:00:00Z", t1: "Netherlands", t2: "Tunisia",               p1: 0.88, pX: 0.09, p2: 0.03 },
  { id: "w12", grp: "F", date: "2026-06-25", koUTC: "2026-06-25T00:00:00Z", t1: "Sweden",      t2: "Japan",                 p1: 0.22, pX: 0.27, p2: 0.51 },
  { id: "w13", grp: "G", date: "2026-06-26", koUTC: "2026-06-26T00:00:00Z", t1: "Belgium",     t2: "New Zealand",           p1: 0.83, pX: 0.12, p2: 0.05 },
  { id: "w14", grp: "G", date: "2026-06-26", koUTC: "2026-06-26T00:00:00Z", t1: "Egypt",       t2: "Iran",                  p1: 0.39, pX: 0.36, p2: 0.25 },
  { id: "w15", grp: "H", date: "2026-06-26", koUTC: "2026-06-26T00:00:00Z", t1: "Spain",       t2: "Uruguay",               p1: 0.64, pX: 0.23, p2: 0.13 },
  { id: "w16", grp: "H", date: "2026-06-26", koUTC: "2026-06-26T00:00:00Z", t1: "Cape Verde",  t2: "Saudi Arabia",          p1: 0.39, pX: 0.28, p2: 0.33 },

  // ── Journée 3 · Groupes I-L ─────────────────────────────────────────────
  { id: "w17", grp: "I", date: "2026-06-26", koUTC: "2026-06-26T00:00:00Z", t1: "France",      t2: "Norway",                p1: 0.59, pX: 0.21, p2: 0.20 },
  { id: "w18", grp: "I", date: "2026-06-26", koUTC: "2026-06-26T00:00:00Z", t1: "Iraq",        t2: "Senegal",               p1: 0.07, pX: 0.15, p2: 0.78 },
  { id: "w19", grp: "J", date: "2026-06-27", koUTC: "2026-06-27T00:00:00Z", t1: "Argentina",   t2: "Jordan",                p1: 0.81, pX: 0.13, p2: 0.06 },
  { id: "w20", grp: "J", date: "2026-06-27", koUTC: "2026-06-27T00:00:00Z", t1: "Algeria",     t2: "Austria",               p1: 0.25, pX: 0.41, p2: 0.34 },
  { id: "w21", grp: "K", date: "2026-06-27", koUTC: "2026-06-27T00:00:00Z", t1: "Portugal",    t2: "Colombia",              p1: 0.52, pX: 0.25, p2: 0.23 },
  { id: "w22", grp: "K", date: "2026-06-27", koUTC: "2026-06-27T00:00:00Z", t1: "Uzbekistan",  t2: "DR Congo",              p1: 0.22, pX: 0.23, p2: 0.55 },
  { id: "w23", grp: "L", date: "2026-06-27", koUTC: "2026-06-27T00:00:00Z", t1: "England",     t2: "Panama",                p1: 0.82, pX: 0.12, p2: 0.06 },
  { id: "w24", grp: "L", date: "2026-06-27", koUTC: "2026-06-27T00:00:00Z", t1: "Croatia",     t2: "Ghana",                 p1: 0.54, pX: 0.29, p2: 0.17 },
];

export const M_BY_ID = Object.fromEntries(MATCHES.map((m) => [m.id, m]));

export const DEF_RES: Record<string, { o: string; s: string }> = {
  m01: { o: "team1", s: "2–0" },
  m02: { o: "team1", s: "2–1" },
  w02: { o: "team1", s: "1–0" },
  u01: { o: "draw",  s: "0–0" },
  u05: { o: "team1", s: "3–0" },
  m03: { o: "draw", s: "1–1" },
  m04: { o: "team1", s: "4–1" },
  m05: { o: "draw", s: "1–1" },
  m06: { o: "draw", s: "1–1" },
  m07: { o: "team1", s: "1–0" },
  m08: { o: "team1", s: "2–0" },
  m09: { o: "team1", s: "7–1" },
  m10: { o: "team1", s: "1–0" },
  m11: { o: "draw", s: "2–2" },
  m12: { o: "team1", s: "5–1" },
};

export const STD_ODDS: [string, number][] = [
  ["commun", 45],
  ["rare", 35],
  ["epic", 15],
  ["ultra", 5],
];

export const PREM_ODDS: [string, number][] = [
  ["commun", 40],
  ["rare", 40],
  ["epic", 15],
  ["ultra", 5],
];

export const FAM_ODDS: [string, number][] = [
  ["commun", 30],
  ["rare", 30],
  ["epic", 20],
  ["ultra", 20],
];

export const STARTER_GOLD = 500;
export const PACK_STD = 100;
export const PACK_PREM = 150;
export const PACK_FAM = 350;
export const LIVE_MS = 115 * 60 * 1000;
export const HDR_OFFSET = 108;
